import React from "react";
import { Slide } from "react-reveal";
import p1 from "../../assets/images/content/p1.jpeg";
import p2 from "../../assets/images/content/p2.jpeg";
import p3 from "../../assets/images/content/p3.jpeg";
import p5 from "../../assets/images/content/p5.jpeg";
import p7 from "../../assets/images/content/p7.jpeg";
import p8 from "../../assets/images/content/p8.jpeg";
import e4 from "../../assets/images/content/e4.jpeg";
import e7 from "../../assets/images/content/e7.jpeg";
import e9 from "../../assets/images/content/e9.jpeg";
import jm2 from "../../assets/images/content/jm2.jpg";
import jm8 from "../../assets/images/content/jm8.jpg";
import j211 from "../../assets/images/content/j211.jpg";
import h2 from "../../assets/images/content/h2.jpeg";
import u1 from "../../assets/images/update1/butt.jpg";
import u2 from "../../assets/images/update1/geosynthetic.jpg";
import u3 from "../../assets/images/update1/hdpe.jpg";
import u4 from "../../assets/images/update1/peel.jpg";
import u5 from "../../assets/images/update1/sump.jpg";
import u6 from "../../assets/images/update1/vaccum1.jpg";
import u7 from "../../assets/images/update1/vaccum2.jpg";
import u8 from "../../assets/images/update1/butt2.jpg";
import u9 from "../../assets/images/update1/hdpe2.jpg";

import ProjectCard from "../reusables/ProjectCard";

const ProjectsBody = () => {
  return (
    <section className="section-spacing-80">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content">
              <div className="section-content">
                <div className="section-body section-spacing-20 width-600 margin-auto">
                  <div class="card-container">
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle in-progress"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong> EPSILON UGANDA</strong>
                        </span>
                        <span class="status in-progress">On going</span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Pipe works - Butt fusion and HDPE Liner Installation
                          for Dam IB at EnviroServ Waste Management Facility
                          Nyamasoga
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle in-progress"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong> EnviroServ Uganda</strong>
                        </span>
                        <span class="status in-progress">On going</span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installation of an HDPE Liner for a leachate
                          collection tank and associated pipe work at EnviroServ
                          Waste Management Facility Nyamasoga
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-Engil Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-15/03/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          HDPE Liner Installation s for CPF-FW and diesel
                          storage tank
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>EnviroServ Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-24/02/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installation of HDPE liner for Cell-1B at EnviroServ
                          Waste Management Facility-Nyamasoga.
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>EPSILON UGANDA</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-24/02/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installing of Geocomposite drain Geosynthetic Clay
                          Liner, Geotextile And Geogrid at EnviroServ Waste
                          Management Facility Nyamasoga Landfill Cell 1 B
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>EPSILON UGANDA</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-24/02/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Butt fusion welding at EnviroServ Waste Management
                          Facility Nyamasoga for Landfill Cell 1 B
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-25/02/2025
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installing of HDPE liner at CPF 4210 and 4150
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-22/02/2025
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installing of HDPE liner at CFT4 JBR09- North
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>EPSILON UGANDA</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-17/01/2025
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Geomembrane Liner Installation at 6 Mud Cutting pits
                          at Tangi Camp – Pakwach.
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-18/09/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Liner installation welding for 02-01-TZ-001 and
                          02-01-TZ-002 Tank 4210
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-21/06/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          HDPE Liner Installation on Tank 02-71-TZ-0001
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-21/06/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Liner installation for 4150 and 4210 Tank Foundation,
                          02-54-TZ-0002.
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-18/04/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installation of HDPE Liner at Gunya 4
                        </p>
                      </div>
                    </div>
                    <div class="recent-project-card">
                      <div className="project-timeline">
                        <div className="circle completed"></div>
                        <div className="line"></div>
                      </div>
                      <div class="card-header">
                        <span>
                          Client:
                          <strong>MOTA-ENGIL Uganda</strong>
                        </span>
                        <span class="status completed">
                          Completed-::-16/05/2024
                        </span>
                      </div>
                      <div>
                        <span>Work Description:</span>
                        <p className="bold">
                          Installation of HDPE Liner at Jbr 3
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="section-body section-spacing-20">
                <ul className="projects-container">
                  <ProjectCard
                    img={u1}
                    caption="Butt Fusion at EnviroServ Waste Management Facility-Nyamasoga"
                  />
                  <ProjectCard
                    img={u8}
                    caption="Butt Fusion at EnviroServ Waste Management Facility-Nyamasoga"
                  />
                  <ProjectCard
                    img={u2}
                    caption="Installation of Geosynthetic Clay at Envirosev Waste Management Facility Landfill "
                  />
                  <ProjectCard
                    img={u3}
                    caption="Workers preparing to install an HDPE Liner at  a landfill at EnviroServ Waste Management Facility"
                  />
                  <ProjectCard
                    img={u9}
                    caption="Installing of HDPE liner at CFT4 JBR09-Buliisa Uganda"
                  />
                  <ProjectCard
                    img={u4}
                    caption="Conducing peel and shear tests for trial welds at CTF 4150 Bullisa Uganda"
                  />
                  <ProjectCard
                    img={u5}
                    caption="Sump lining using an extruder and hot wedge at CTF4150-Buliisa Uganda"
                  />
                  <ProjectCard
                    img={u6}
                    caption="Vacuum box testing and Air pressure testing at EnviroServ Waste Management Facility-Nyamasoga"
                  />
                  <ProjectCard
                    img={u7}
                    caption="Vacuum box testing and Air pressure testing at EnviroServ Waste Management Facility-Nyamasoga"
                  />
                  <ProjectCard
                    img={p3}
                    caption="Line repair, Kingfisher Oil waste management facility in Kyangwali, Kikuube District."
                  />
                  <ProjectCard
                    img={p8}
                    caption="Leachate collection pit, Kingfisher Oil waste management facility in Kyangwali, Kikuube District."
                  />
                  <ProjectCard
                    img={p1}
                    caption="Lining of tyre wash train pit, Kingfisher Oil waste management facility in Kyangwali, Kikuube District."
                  />
                  <ProjectCard
                    img={p2}
                    caption="Storm water evaporation pit, Luwero Industries Limited (Kingfisher Oil waste management facility)"
                  />
                  <ProjectCard
                    img={p7}
                    caption="HDPE Weilding, Luwero Industries Limited (Kingfisher Oil waste management facility)"
                  />
                  <ProjectCard
                    img={p5}
                    caption="Leachate collection pit, Kingfisher Oil waste management facility in Kyangwali, Kikuube District."
                  />

                  <ProjectCard
                    img={e7}
                    caption="Environmental Restoration, Kyangwali Luweero Industries, Waste management facility"
                  />
                  <ProjectCard
                    img={e9}
                    caption="Environmental Restoration, Kyangwali Luweero Industries, Waste management facility"
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsBody;
